import React from 'react'
import './Home.css'
import Product from './Product'

const Home = () => {
    return (
        <div className='home'>
            <img className='home_image' src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/gateway/placement/launch/PalmSprings/PLMS_2021_GWBleedingHero_FT_COVIDUPDATE_XSite_1500X600_PV_en-GB._CB656407890_.jpg" alt="" />


            {/* product id, title, price, rating, image , */}

            {/* 1st row product */}
            <div className="home_row">
                <Product
                
                id='1234'
                title='DSLR Cemara is the good product.It is very high quility product.Plz buy it 🚀'
                price={100.75}
                rating={5}
                image='https://www.awesomedynamic.com/wp-content/uploads/2018/02/awesome-dynamic-amazon-product-photography-camera.png'
                />
                <Product
                
                id='123456'
                title='Lady Bag is the good product.It is very high quility product.Plz buy it 🚀'
                price={20.50}
                rating={3}
                image='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCqGkdKce9O9f4A75OInUTelRXwTSOcEIE5g&usqp=CAU'
                />
             </div>
          
           {/* 2nd row product */}
           <div className="home_row">
                <Product
                
                id='1234'
                title='Sound specker is the good product.It is very high quility product.Plz buy it 🚀'
                price={50.75}
                rating={4}
                image='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvFtNUqjKJ7-kN5mLiU_dP2OSCh3n2j9HduA&usqp=CAU'
                />
                <Product
                
                id='123456'
                title='Paper Box is the good product.It is very high quility product.Plz buy it 🚀'
                price={10.50}
                rating={2}
                image='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQxh9F_UP8C-3j1BMxQRv1Mvmjai8s6p0VcAg&usqp=CAU'
                />

              <Product
                
                id='123456'
                title='Water is the good product.It is very high quility product.Plz buy it 🚀'
                price={20.50}
                rating={4}
                image='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZ-g6KYi4U9Qip5bXP99TVmLm9oO0u1Uih1Q&usqp=CAU'
                />
             </div>


             {/* 3rd row */}

             <div className="home_row">
             <Product
                
                id='123456'
                title='Watch is the good product.It is very high quility product.Plz buy it 🚀'
                price={20.50}
                rating={3}
                image='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZU7Jx5-wlgVYcjKqBwTEhyDAgFVw8CG_1KA&usqp=CAU'
                />
             </div>


        </div>
    )
}

export default Home
